import { useTranslation } from "react-i18next";
import type { BoardMeta, IconRef, SentenceToken } from "../game/types";
import IconCell from "./IconCell";
import { iconKey } from "../game/types";
import type { Lang } from "../i18n";

interface Props {
  board: BoardMeta;
  tokensByIcon: Map<string, SentenceToken>;
  onCellClick?: (ref: IconRef) => void;
  showSolutionGlossFor?: Set<string>;
}

const COLS = ["A", "B", "C", "D"] as const;
const ROWS = [1, 2, 3, 4] as const;

export default function Board({ board, tokensByIcon, onCellClick, showSolutionGlossFor }: Props) {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage as Lang) ?? "en";
  const theme = board.theme[lang] ?? board.theme.en;
  return (
    <div className="board">
      <div className="board__id board__id--tl">{board.id}</div>
      <div className="board__id board__id--br">{board.id}</div>
      <div className="board__theme">{theme}</div>
      <div className="board__row-labels">
        {ROWS.map((r) => <span key={r}>{r}</span>)}
      </div>
      <div className="board__col-labels">
        {COLS.map((c) => <span key={c}>{c}</span>)}
      </div>
      <div className="board__inner">
        {board.cells.map((cell) => {
          const k = iconKey(cell.ref);
          const token = tokensByIcon.get(k);
          return (
            <IconCell
              key={k}
              cellRef={cell.ref}
              token={token}
              onClick={onCellClick}
              showSolutionGloss={showSolutionGlossFor?.has(k)}
            />
          );
        })}
      </div>
    </div>
  );
}
